export const DELETE_HEADER = className => 'Delete ' + className + '?'
export const DELETE_MESSAGE = "If you delete it, it's gone forever."
export const DELETE_NOTICE =
  'This class will no longer appear on your SecondStep.org dashboard, and its data will be permanently lost.'
export const DELETE_CONFIRM = 'Got it'
export const DELETE_SUBMIT = 'DELETE CLASS'
export const DELETE_CANCEL = 'CANCEL'
